















import Vue, {VueConstructor} from 'vue'
import maskInput from '../inputs/mask.vue'
export default Vue.extend({
  name: 'MaskField',
  components: {maskInput},
  props: {
    value: {},
    label: String,
    error: Boolean,
    field: String,
    placeholder: String,
    required: Boolean,
    mask: {
      type: String,
      default: ''
    }
  },
  methods: {
    onInput (event: any): any {
      this.$emit('input', event)
    },
    onFocus (event: any): any {
      this.$emit('focus', event)
    },
    onBlur (event: any): any {
      this.$emit('blur', event)
    }
  },
  computed: {
    fieldValue: {
      get (): any {
        return this.value
      },
      set (): any {
      }
    } as any
  }
})
